import React from 'react';
import { Text } from '@atlaskit/primitives';
import { components } from '@atlaskit/react-select';
/**
 * __No options message__
 */
export const NoOptionsMessage = props => {
  return /*#__PURE__*/React.createElement(components.NoOptionsMessage, props, /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtle"
  }, props.children || `No options`));
};